import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sortBy: "title",
  orderBy: "asc",
};

const meetingEventSlice = createSlice({
  name: "meetingEvents",
  initialState,
  reducers: {
    updateEventSortBy(state, action) {
      state.sortBy = action.payload;
    },

    updateEventOrderBy(state, action) {
      state.orderBy = action.payload;
    },
  },
});

export const { updateEventOrderBy, updateEventSortBy } = meetingEventSlice.actions;

export default meetingEventSlice.reducer;
